function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 49,
  height: 49,
  stroke: "#2D577D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2369 27.0387L30.5 24.5774L34.7631 27.0387V31.9613L30.5 34.4226L26.2369 31.9613V27.0387Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2369 9.03867L30.5 6.57735L34.7631 9.03867V13.9613L30.5 16.4226L26.2369 13.9613V9.03867Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2369 9.03867L41.5 6.57735L45.7631 9.03867V13.9613L41.5 16.4226L37.2369 13.9613V9.03867Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2369 27.0387L19.5 24.5774L23.7631 27.0387V31.9613L19.5 34.4226L15.2369 31.9613V27.0387Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7369 36.0387L25 33.5774L29.2631 36.0387V40.9613L25 43.4226L20.7369 40.9613V36.0387Z",
  fill: "#047E2E",
  fillOpacity: 0.5,
  stroke: "#047E2E"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M15.2369 9.03867L19.5 6.57735L23.7631 9.03867V13.9613L19.5 16.4226L15.2369 13.9613V9.03867Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M4.23686 9.03867L8.5 6.57735L12.7631 9.03867V13.9613L8.5 16.4226L4.23686 13.9613L4.23686 9.03867Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7369 18.0387L25 15.5774L29.2631 18.0387V22.9613L25 25.4226L20.7369 22.9613V18.0387Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M9.73686 18.0387L14 15.5774L18.2631 18.0387V22.9613L14 25.4226L9.73686 22.9613V18.0387Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M31.7369 18.0387L36 15.5774L40.2631 18.0387V22.9613L36 25.4226L31.7369 22.9613V18.0387Z",
  fill: "currentColor",
  fillOpacity: 0.5,
  stroke: "currentColor"
});

function SvgSpread(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    className: "bg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpread);
export default __webpack_public_path__ + "static/media/spread.47a9f72c.svg";
export { ForwardRef as ReactComponent };